/* src/components/Button/Button.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	attr,
	bubble,
	check_outros,
	create_slot,
	detach,
	element,
	empty,
	get_all_dirty_from_scope,
	get_slot_changes,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	run_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_slot_base
} from "svelte/internal";

import { tippy, tippy_menu } from "../../actions/tippy";

function create_else_block_1(ctx) {
	let button;
	let button_class_value;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[9].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);

	return {
		c() {
			button = element("button");
			if (default_slot) default_slot.c();
			attr(button, "class", button_class_value = "" + (/*name*/ ctx[1] + "-btn " + /*className*/ ctx[0] + " " + /*theme*/ ctx[2]));
			button.disabled = /*disabled*/ ctx[3];
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (default_slot) {
				default_slot.m(button, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler_2*/ ctx[12]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[8], dirty, null),
						null
					);
				}
			}

			if (!current || dirty & /*name, className, theme*/ 7 && button_class_value !== (button_class_value = "" + (/*name*/ ctx[1] + "-btn " + /*className*/ ctx[0] + " " + /*theme*/ ctx[2]))) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*disabled*/ 8) {
				button.disabled = /*disabled*/ ctx[3];
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

// (13:0) {#if content}
function create_if_block(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*menu*/ ctx[6]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (33:2) {:else}
function create_else_block(ctx) {
	let button;
	let button_class_value;
	let tippy_action;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[9].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);

	return {
		c() {
			button = element("button");
			if (default_slot) default_slot.c();
			attr(button, "class", button_class_value = "" + (/*name*/ ctx[1] + "-btn " + /*className*/ ctx[0] + " " + /*theme*/ ctx[2]));
			button.disabled = /*disabled*/ ctx[3];
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (default_slot) {
				default_slot.m(button, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					listen(button, "click", /*click_handler_1*/ ctx[11]),
					action_destroyer(tippy_action = tippy.call(null, button, {
						content: /*content*/ ctx[4],
						placement: /*placement*/ ctx[5],
						className: /*className*/ ctx[0]
					}))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[8], dirty, null),
						null
					);
				}
			}

			if (!current || dirty & /*name, className, theme*/ 7 && button_class_value !== (button_class_value = "" + (/*name*/ ctx[1] + "-btn " + /*className*/ ctx[0] + " " + /*theme*/ ctx[2]))) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*disabled*/ 8) {
				button.disabled = /*disabled*/ ctx[3];
			}

			if (tippy_action && is_function(tippy_action.update) && dirty & /*content, placement, className*/ 49) tippy_action.update.call(null, {
				content: /*content*/ ctx[4],
				placement: /*placement*/ ctx[5],
				className: /*className*/ ctx[0]
			});
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (14:2) {#if menu}
function create_if_block_1(ctx) {
	let span1;
	let button;
	let button_class_value;
	let tippy_action;
	let t;
	let span0;
	let span0_class_value;
	let span1_class_value;
	let tippy_action_1;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[9].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);

	return {
		c() {
			span1 = element("span");
			button = element("button");
			if (default_slot) default_slot.c();
			t = space();
			span0 = element("span");
			attr(button, "class", button_class_value = "" + (/*name*/ ctx[1] + "-btn " + /*className*/ ctx[0] + " " + /*theme*/ ctx[2]));
			button.disabled = /*disabled*/ ctx[3];
			attr(span0, "class", span0_class_value = "" + (/*name*/ ctx[1] + "-triangle"));
			attr(span1, "class", span1_class_value = "" + (/*name*/ ctx[1] + "-btn-interactive " + /*theme*/ ctx[2]));
		},
		m(target, anchor) {
			insert(target, span1, anchor);
			append(span1, button);

			if (default_slot) {
				default_slot.m(button, null);
			}

			append(span1, t);
			append(span1, span0);
			current = true;

			if (!mounted) {
				dispose = [
					listen(button, "click", /*click_handler*/ ctx[10]),
					action_destroyer(tippy_action = tippy.call(null, button, {
						content: /*menu*/ ctx[6],
						...tippy_menu,
						placement: /*menu_placement*/ ctx[7],
						appendTo: document.body,
						theme: /*theme*/ ctx[2],
						className: "fastboard-panel"
					})),
					action_destroyer(tippy_action_1 = tippy.call(null, span1, {
						content: /*content*/ ctx[4],
						placement: /*placement*/ ctx[5],
						className: /*className*/ ctx[0]
					}))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[8], dirty, null),
						null
					);
				}
			}

			if (!current || dirty & /*name, className, theme*/ 7 && button_class_value !== (button_class_value = "" + (/*name*/ ctx[1] + "-btn " + /*className*/ ctx[0] + " " + /*theme*/ ctx[2]))) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*disabled*/ 8) {
				button.disabled = /*disabled*/ ctx[3];
			}

			if (tippy_action && is_function(tippy_action.update) && dirty & /*menu, menu_placement, theme*/ 196) tippy_action.update.call(null, {
				content: /*menu*/ ctx[6],
				...tippy_menu,
				placement: /*menu_placement*/ ctx[7],
				appendTo: document.body,
				theme: /*theme*/ ctx[2],
				className: "fastboard-panel"
			});

			if (!current || dirty & /*name*/ 2 && span0_class_value !== (span0_class_value = "" + (/*name*/ ctx[1] + "-triangle"))) {
				attr(span0, "class", span0_class_value);
			}

			if (!current || dirty & /*name, theme*/ 6 && span1_class_value !== (span1_class_value = "" + (/*name*/ ctx[1] + "-btn-interactive " + /*theme*/ ctx[2]))) {
				attr(span1, "class", span1_class_value);
			}

			if (tippy_action_1 && is_function(tippy_action_1.update) && dirty & /*content, placement, className*/ 49) tippy_action_1.update.call(null, {
				content: /*content*/ ctx[4],
				placement: /*placement*/ ctx[5],
				className: /*className*/ ctx[0]
			});
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(span1);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block, create_else_block_1];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*content*/ ctx[4]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { class: className = "" } = $$props;
	let { name = "fastboard-ui" } = $$props;
	let { theme = "light" } = $$props;
	let { disabled = false } = $$props;
	let { content = "" } = $$props;
	let { placement = "top" } = $$props;
	let { menu = "" } = $$props;
	let { menu_placement = "right-start" } = $$props;

	function click_handler(event) {
		bubble.call(this, $$self, event);
	}

	function click_handler_1(event) {
		bubble.call(this, $$self, event);
	}

	function click_handler_2(event) {
		bubble.call(this, $$self, event);
	}

	$$self.$$set = $$props => {
		if ('class' in $$props) $$invalidate(0, className = $$props.class);
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('theme' in $$props) $$invalidate(2, theme = $$props.theme);
		if ('disabled' in $$props) $$invalidate(3, disabled = $$props.disabled);
		if ('content' in $$props) $$invalidate(4, content = $$props.content);
		if ('placement' in $$props) $$invalidate(5, placement = $$props.placement);
		if ('menu' in $$props) $$invalidate(6, menu = $$props.menu);
		if ('menu_placement' in $$props) $$invalidate(7, menu_placement = $$props.menu_placement);
		if ('$$scope' in $$props) $$invalidate(8, $$scope = $$props.$$scope);
	};

	return [
		className,
		name,
		theme,
		disabled,
		content,
		placement,
		menu,
		menu_placement,
		$$scope,
		slots,
		click_handler,
		click_handler_1,
		click_handler_2
	];
}

class Button extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			class: 0,
			name: 1,
			theme: 2,
			disabled: 3,
			content: 4,
			placement: 5,
			menu: 6,
			menu_placement: 7
		});
	}
}

export default Button;